import PageContainerV4 from '../../common/component/PageContainerV4';
import {IProps as IPageContainerProps} from '../../common/component/PageContainerV4';
import {HEADER_HEIGHT} from '../../common/scss/util/variable';
import useChangeWebviewTermsTitle from '../hook/useChangeWebviewTermsTitle';

interface IProps extends IPageContainerProps {
  title?: string;
  wrapperClassName?: string;
  className?: string;
  isWebview?: boolean;
  isTerms?: boolean;
  isHiddenLeftIcon?: boolean;
  isShortHeaderGradient?: boolean;
  hasMdWidth?: boolean;
}

export default function MoreContainerV4({
  title,
  onClickHeaderButton,
  isWebview,
  className,
  wrapperClassName,
  children,
  isTerms,
  isHiddenLeftIcon,
  rightElement,
  leftElement,
  isShortHeaderGradient,
  tabElement,
  hasMdWidth,
  ...rest
}: IProps) {
  useChangeWebviewTermsTitle(title);

  return (
    <PageContainerV4
      title={title}
      tabElement={tabElement}
      onClickHeaderButton={onClickHeaderButton}
      showHeader={!isWebview}
      leftElement={
        leftElement ? leftElement : isHiddenLeftIcon ? <></> : undefined
      }
      rightElement={rightElement}
      wrapperClassName={cn(wrapperClassName, {
        'pb-30 px-11': isTerms,
      })}
      gradientStyle={{
        height: isShortHeaderGradient ? HEADER_HEIGHT : undefined,
      }}
      {...rest}
    >
      <div
        className={cn(
          {
            'leading-[1.3] px-18 py-24 rounded-12 bg-grey-01 light:bg-white':
              isTerms,
            'px-11': !isTerms,
            'mt-10': !isWebview,
            'md:w-[490px] lg:w-[630px] mx-auto': hasMdWidth,
          },
          className
        )}
      >
        {children}
      </div>
    </PageContainerV4>
  );
}
